(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.vm-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vm-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el, i) {
      el.style.setProperty('--vm-delay', Math.min(i % 6, 5) * 80 + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var VM_WISHLIST_KEY = 'vm_wishlist';

  function vmGetWishlist() {
    try {
      return JSON.parse(localStorage.getItem(VM_WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function vmSaveWishlist(list) {
    localStorage.setItem(VM_WISHLIST_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('vm:wishlist:change', { detail: { list: list } }));
  }

  function vmToggleWishlist(item) {
    var list = vmGetWishlist();
    var idx = list.findIndex(function (p) { return p.id === item.id; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
    vmSaveWishlist(list);
    return idx === -1;
  }

  function vmIsWishlisted(id) {
    return vmGetWishlist().some(function (p) { return p.id === id; });
  }

  function updateWishlistCount() {
    var count = vmGetWishlist().length;
    document.querySelectorAll('[data-vm-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function paintWishlistButtons() {
    document.querySelectorAll('[data-vm-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-vm-wishlist-toggle');
      btn.classList.toggle('is-active', vmIsWishlisted(id));
      btn.setAttribute('aria-pressed', vmIsWishlisted(id) ? 'true' : 'false');
    });
  }

  function initWishlistButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vm-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var item = {
        id: btn.getAttribute('data-vm-wishlist-toggle'),
        title: btn.getAttribute('data-vm-title') || '',
        image: btn.getAttribute('data-vm-image') || '',
        price: btn.getAttribute('data-vm-wl-price') || '',
        url: btn.getAttribute('data-vm-url') || '#'
      };
      vmToggleWishlist(item);
      paintWishlistButtons();
      updateWishlistCount();
    });

    document.addEventListener('vm:wishlist:change', renderWishlistDrawer);
    updateWishlistCount();
    paintWishlistButtons();
    renderWishlistDrawer();
  }

  function renderWishlistDrawer() {
    var mount = document.querySelector('[data-vm-wishlist-list]');
    if (!mount) return;
    var list = vmGetWishlist();
    if (!list.length) {
      mount.innerHTML = '<p class="vm-wishlist-empty">Your wishlist is empty.</p>';
      return;
    }
    mount.innerHTML = list.map(function (item) {
      return '' +
        '<div class="vm-wishlist-item">' +
        '  <a href="' + item.url + '" class="vm-wishlist-item__img">' +
        (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '  </a>' +
        '  <div class="vm-wishlist-item__body">' +
        '    <a href="' + item.url + '" class="vm-wishlist-item__title">' + item.title + '</a>' +
        '    <span class="vm-wishlist-item__price">' + item.price + '</span>' +
        '  </div>' +
        '  <button type="button" class="vm-wishlist-item__remove" data-vm-wishlist-toggle="' + item.id + '" data-vm-title="' + item.title + '" aria-label="Remove">&times;</button>' +
        '</div>';
    }).join('');
  }

  /* ---------- Drawer open/close (wishlist panel) ---------- */
  function initDrawerTriggers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vm-drawer-open]');
      if (opener) {
        var id = opener.getAttribute('data-vm-drawer-open');
        var drawer = document.getElementById(id);
        if (drawer) {
          drawer.classList.add('is-open');
          document.body.classList.add('vm-drawer-locked');
        }
      }
      var closer = e.target.closest('[data-vm-drawer-close]');
      if (closer) {
        var d = closer.closest('.vm-drawer');
        if (d) d.classList.remove('is-open');
        document.body.classList.remove('vm-drawer-locked');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.vm-drawer.is-open').forEach(function (d) {
          d.classList.remove('is-open');
        });
        document.body.classList.remove('vm-drawer-locked');
      }
    });
  }

  /* ---------- Mobile menu: keep the opened submenu in view ----------
     Subcategories (e.g. Dresses) now expand inline instead of sliding in as
     a separate full-screen panel, which pushes the rest of the list down
     and can push it past the bottom of the drawer. Smoothly scroll the
     drawer so the parent item and its newly-revealed children land near
     the top of the visible area, keeping as much of the rest of the menu
     reachable on screen as possible. */
  function initMenuDrawerAutoScroll() {
    var container = document.querySelector('.menu-drawer__navigation-container');
    if (!container) return;
    document.addEventListener('toggle', function (e) {
      var details = e.target;
      if (!details.matches || !details.matches('.menu-drawer__navigation details')) return;
      if (!details.open) return;
      setTimeout(function () {
        var summary = details.querySelector(':scope > summary');
        if (!summary) return;
        var containerRect = container.getBoundingClientRect();
        var summaryRect = summary.getBoundingClientRect();
        var offset = summaryRect.top - containerRect.top + container.scrollTop - 8;
        container.scrollTo({ top: offset, behavior: 'smooth' });
      }, 50);
    }, true);
  }

  /* ---------- Product card hover image swap ---------- */
  function initCardHoverImages() {
    document.querySelectorAll('[data-vm-card-media]').forEach(function (card) {
      var imgs = card.querySelectorAll('[data-vm-card-img]');
      if (imgs.length < 2) return;
      card.addEventListener('mouseenter', function () {
        /* Once the shopper has picked a color swatch, the secondary
           "hover preview" image is unrelated to that color and would
           visually mask it — skip the hover swap for that card. */
        if (imgs[0].dataset.vmSelectedSrc) return;
        imgs[0].style.opacity = '0';
        imgs[1].style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        if (imgs[0].dataset.vmSelectedSrc) return;
        imgs[0].style.opacity = '1';
        imgs[1].style.opacity = '0';
      });
    });
  }

  /* ---------- Accordion (product tabs) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-vm-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* ---------- Color swatch -> variant swap on card ---------- */
  function initSwatchPreview() {
    /* The primary card <img> carries a srcset attribute for responsive loading.
       Per spec, srcset wins over src when both are present, so just setting
       img.src here silently does nothing in the browser unless srcset is
       also cleared — this was why swatch clicks failed to change the photo. */
    document.addEventListener('mouseenter', function (e) {
      var swatch = e.target.closest ? e.target.closest('[data-vm-swatch-image]') : null;
      if (!swatch) return;
      var card = swatch.closest('[data-vm-card-media]');
      if (!card) return;
      var img = card.querySelector('[data-vm-card-img]');
      if (!img) return;
      img.dataset.vmOriginalSrc = img.dataset.vmOriginalSrc || img.src;
      if (img.dataset.vmOriginalSrcset === undefined) img.dataset.vmOriginalSrcset = img.srcset || '';
      img.removeAttribute('srcset');
      img.src = swatch.getAttribute('data-vm-swatch-image');
    }, true);
    document.addEventListener('mouseleave', function (e) {
      var swatch = e.target.closest ? e.target.closest('[data-vm-swatch-image]') : null;
      if (!swatch) return;
      var card = swatch.closest('[data-vm-card-media]');
      if (!card) return;
      var img = card.querySelector('[data-vm-card-img]');
      if (img && img.dataset.vmOriginalSrc && !img.dataset.vmSelectedSrc) {
        img.src = img.dataset.vmOriginalSrc;
        if (img.dataset.vmOriginalSrcset) img.srcset = img.dataset.vmOriginalSrcset;
      }
    }, true);
    /* Click/tap selects a color permanently (needed on mobile, no hover).
       Scoped to .vm-card__swatch (not just swatches with an image) so a
       color still gets a visible "selected" state even on the rare variant
       that has no dedicated photo in Shopify — a missing photo shouldn't
       make the swatch feel unresponsive. */
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest ? e.target.closest('.vm-card__swatch') : null;
      if (!swatch) return;
      var card = swatch.closest('[data-vm-card-media]');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      var group = swatch.closest('.vm-card__swatches');
      if (group) {
        group.querySelectorAll('.vm-card__swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      }
      swatch.classList.add('is-selected');
      var swatchImage = swatch.getAttribute('data-vm-swatch-image');
      if (!swatchImage) return;
      var img = card.querySelector('[data-vm-card-img]');
      if (!img) return;
      img.dataset.vmOriginalSrc = img.dataset.vmOriginalSrc || img.src;
      if (img.dataset.vmOriginalSrcset === undefined) img.dataset.vmOriginalSrcset = img.srcset || '';
      img.removeAttribute('srcset');
      img.dataset.vmSelectedSrc = swatchImage;
      img.src = swatchImage;
      /* Force the chosen color's image to actually be the one visible —
         a lingering hover state can otherwise leave the unrelated second
         "hover preview" image opaque on top of it, especially on touch. */
      img.style.opacity = '1';
      var otherImgs = card.querySelectorAll('[data-vm-card-img]');
      if (otherImgs[1]) otherImgs[1].style.opacity = '0';
    });
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vm-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-vm-quick-add');
      if (!variantId) return;
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionIds = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        btn.textContent = 'Added';
        document.querySelectorAll('.vm-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
        document.body.classList.remove('vm-drawer-locked');
        if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1400);
      }).catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1400);
      });
    });
  }

  /* ---------- Quick view ---------- */
  function vmRenderQuickView(product) {
    var body = document.querySelector('[data-vm-quick-view-body]');
    if (!body) return;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var hasVariants = !product.options_with_values || product.variants.length > 1;
    var optionsHtml = '';
    if (product.options_with_values) {
      product.options_with_values.forEach(function (opt, idx) {
        optionsHtml += '<div class="vm-option" data-vm-option-index="' + idx + '">' +
          '<div class="vm-option__label"><span>' + opt.name + '</span><span data-vm-option-current>' + opt.values[0] + '</span></div>' +
          '<div class="vm-option__values">' +
          opt.values.map(function (v, i) {
            return '<span class="vm-option__pill' + (i === 0 ? ' is-selected' : '') + '" data-value="' + v + '">' + v + '</span>';
          }).join('') +
          '</div></div>';
      });
    }
    var firstVariant = product.variants[0];
    body.innerHTML =
      '<div class="vm-quick-view__media">' +
      (image ? '<img src="' + image.replace(/(\.[a-z]+)(\?.*)?$/i, '') + '" alt="' + product.title.replace(/"/g, '&quot;') + '">' : '<span class="vm-card__placeholder"></span>') +
      '</div>' +
      '<div class="vm-quick-view__info">' +
      '<h2 class="vm-heading vm-quick-view__title">' + product.title + '</h2>' +
      '<div class="vm-product-price"><span class="vm-product-price__now" data-vm-price>' + vmFormatMoney(firstVariant.price) + '</span>' +
      '<span class="vm-product-price__compare" data-vm-compare-price' + (firstVariant.compare_at_price > firstVariant.price ? '' : ' hidden') + '>' +
      (firstVariant.compare_at_price > firstVariant.price ? vmFormatMoney(firstVariant.compare_at_price) : '') + '</span>' +
      '</div>' +
      '<div data-vm-variant-picker>' +
      '<script type="application/json" data-vm-variants-json>' + JSON.stringify(product.variants.map(function (v) {
        return {
          id: v.id,
          available: v.available,
          options: v.options,
          price_formatted: vmFormatMoney(v.price),
          compare_at_price_formatted: v.compare_at_price > v.price ? vmFormatMoney(v.compare_at_price) : null
        };
      })) + '<' + '/script>' +
      optionsHtml +
      '</div>' +
      '<button type="button" class="vm-btn vm-btn--primary vm-btn--block" data-vm-quick-add="' + firstVariant.id + '" ' + (firstVariant.available ? '' : 'disabled') + '>' +
      (firstVariant.available ? 'Add to Bag' : 'Sold Out') +
      '</button>' +
      '<a href="' + product.url + '" class="vm-quick-view__link">View full details</a>' +
      '</div>';

    initVariantPickerIn(body);
  }

  function vmFormatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initQuickView() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vm-quick-view]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-vm-quick-view');
      var modal = document.getElementById('vm-quick-view');
      var body = document.querySelector('[data-vm-quick-view-body]');
      if (!modal || !body) return;
      body.innerHTML = '<div class="vm-quick-view__loading">Loading…</div>';
      modal.classList.add('is-open');
      document.body.classList.add('vm-drawer-locked');
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(vmRenderQuickView)
        .catch(function () {
          body.innerHTML = '<p class="vm-quick-view__loading">Couldn\'t load this product.</p>';
        });
    });
  }

  /* ---------- Product carousel ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-vm-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-vm-carousel-track]');
      var prev = carousel.querySelector('[data-vm-carousel-prev]');
      var next = carousel.querySelector('[data-vm-carousel-next]');
      if (!track) return;
      function scrollByCard(dir) {
        var card = track.firstElementChild;
        var amount = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * dir, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  /* ---------- Share product ---------- */
  function initShareButton() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vm-share]');
      if (!btn) return;
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          var original = btn.querySelector('span:last-child');
          if (!original) return;
          var prevText = original.textContent;
          original.textContent = 'Link copied';
          setTimeout(function () { original.textContent = prevText; }, 1800);
        }).catch(function () {});
      }
    });
  }

  /* ---------- Zoom on hover ---------- */
  function initZoom() {
    document.querySelectorAll('[data-vm-zoom]').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;
      wrap.addEventListener('mousemove', function (e) {
        var rect = wrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      wrap.addEventListener('mouseenter', function () { img.classList.add('is-zoomed'); });
      wrap.addEventListener('mouseleave', function () { img.classList.remove('is-zoomed'); });
    });
  }

  /* ---------- Product page form (AJAX add-to-cart) ---------- */
  function initProductForm() {
    var form = document.getElementById('VmProductForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-vm-add-to-cart]');
      if (submitBtn && submitBtn.disabled) return;
      var original = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }
      var cartDrawer = document.querySelector('cart-drawer');
      var formData = new FormData(form);
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = original;
            }
            window.alert(data.description || 'Couldn\'t add this product to your cart.');
            return;
          }
          if (submitBtn) submitBtn.textContent = 'Added';
          if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = original;
              submitBtn.disabled = false;
            }
          }, 1200);
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = original;
          }
        });
    });
  }

  /* ---------- Transparent header over hero ---------- */
  function initTransparentHeader() {
    var header = document.querySelector('.vm-header--transparent');
    if (!header) return;
    function update() {
      header.classList.toggle('vm-scrolled', window.scrollY > 40);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Frequently bought together ---------- */
  function initFrequentlyBoughtTogether() {
    document.querySelectorAll('[data-vm-fbt]').forEach(function (root) {
      var totalEl = root.querySelector('[data-vm-fbt-total]');
      var addBtn = root.querySelector('[data-vm-fbt-add]');
      var baseVariantId = addBtn ? addBtn.getAttribute('data-vm-base-variant') : null;
      // Reads the raw-cents value Liquid outputs directly, rather than
      // scraping the formatted "€37,95" text — that parsing assumed a
      // period decimal separator and silently produced a ~100x-inflated
      // total for comma-decimal currencies (EUR here).
      var basePriceCents = parseInt(root.getAttribute('data-vm-fbt-base-price'), 10) || 0;

      function recompute() {
        var total = basePriceCents;
        root.querySelectorAll('[data-vm-fbt-checkbox]:checked').forEach(function (cb) {
          total += parseInt(cb.getAttribute('data-vm-fbt-price'), 10) || 0;
        });
        if (totalEl) totalEl.textContent = vmFormatMoney(total);
      }

      root.addEventListener('change', function (e) {
        if (e.target.matches('[data-vm-fbt-checkbox]')) recompute();
      });
      recompute();

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          if (baseVariantId) items.push({ id: baseVariantId, quantity: 1 });
          root.querySelectorAll('[data-vm-fbt-checkbox]:checked').forEach(function (cb) {
            items.push({ id: cb.getAttribute('data-vm-fbt-variant'), quantity: 1 });
          });
          if (!items.length) return;
          addBtn.disabled = true;
          var original = addBtn.textContent;
          addBtn.textContent = 'Agregando…';
          var cartDrawer = document.querySelector('cart-drawer');
          var sectionIds = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
            : [];
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: sectionIds })
          }).then(function (r) { return r.json(); }).then(function (data) {
            addBtn.textContent = 'Added';
            if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1400);
          }).catch(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          });
        });
      }
    });
  }

  /* ---------- Cart drawer cross-sells ---------- */
  function initCartCrossSell() {
    function populate() {
      var mount = document.querySelector('[data-vm-cart-cross-sell]');
      if (!mount || mount.dataset.vmPopulated) return;
      var productId = mount.getAttribute('data-vm-seed-product-id');
      if (!productId) return;
      mount.dataset.vmPopulated = 'true';
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).slice(0, 4);
          if (!products.length) return;
          mount.innerHTML = '<p class="vm-cart-cross-sell__heading">You Might Also Like</p>' +
            '<div class="vm-cart-cross-sell__grid">' +
            products.map(function (p) {
              var img = p.featured_image || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
              var variant = p.variants && p.variants[0];
              return '<div class="vm-cart-cross-sell__item">' +
                '<a href="' + p.url + '" class="vm-cart-cross-sell__media">' + (img ? '<img src="' + img + '" alt="" loading="eager">' : '') + '</a>' +
                '<a href="' + p.url + '" class="vm-cart-cross-sell__title">' + p.title + '</a>' +
                '<span class="vm-cart-cross-sell__price">' + vmFormatMoney(p.price) + '</span>' +
                (variant ? '<button type="button" class="vm-cart-cross-sell__add" data-vm-quick-add="' + variant.id + '" aria-label="Add">+</button>' : '') +
                '</div>';
            }).join('') +
            '</div>';
        })
        .catch(function () {});
    }
    populate();
    document.addEventListener('cart:refresh', populate);
  }

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-vm-sticky-atc]');
    var mainBtn = document.querySelector('[data-vm-add-to-cart]');
    if (!bar || !mainBtn) return;
    var stickyBtn = bar.querySelector('[data-vm-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('VmProductForm');
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
      });
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ---------- Gallery thumbnails ---------- */
  function initGallery() {
    document.querySelectorAll('[data-vm-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-vm-gallery-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.vm-product-gallery__slide');
      var segments = gallery.querySelectorAll('.vm-product-gallery__segment');
      var prevBtn = gallery.querySelector('[data-vm-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-vm-gallery-next]');
      var media = gallery.closest('.vm-product-media') || gallery.parentElement;
      var thumbs = media ? media.querySelectorAll('[data-vm-gallery-thumb]') : [];

      function setActive(idx) {
        segments.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        if (prevBtn) prevBtn.disabled = idx === 0;
        if (nextBtn) nextBtn.disabled = idx === slides.length - 1;
      }

      function scrollToIndex(idx) {
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        var target = slides[idx];
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }

      var lastIdx = 0;
      if (slides.length > 1) {
        setInterval(function () {
          if (!track.clientWidth) return;
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          if (idx !== lastIdx) {
            lastIdx = idx;
            setActive(idx);
          }
        }, 120);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(lastIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(lastIdx + 1); });

      thumbs.forEach(function (thumb, idx) {
        thumb.addEventListener('click', function () { scrollToIndex(idx); });
      });

      setActive(0);

      gallery.vmScrollToImage = function (src) {
        var idx = Array.prototype.findIndex.call(slides, function (s) {
          return s.getAttribute('data-vm-gallery-slide-src') === src;
        });
        if (idx > -1) scrollToIndex(idx);
      };
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickerIn(scope) {
    scope.querySelectorAll('[data-vm-variant-picker]').forEach(function (root) {
      if (root.dataset.vmBound) return;
      root.dataset.vmBound = 'true';
      var dataEl = root.querySelector('[data-vm-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = root.querySelector('[data-vm-variant-id]') || scope.querySelector('[data-vm-variant-id]');
      var priceEl = scope.querySelector('[data-vm-price]');
      var compareEl = scope.querySelector('[data-vm-compare-price]');
      var saveBadge = scope.querySelector('[data-vm-save-badge]');
      var submitBtn = scope.querySelector('[data-vm-add-to-cart]');
      var buyNowBtn = scope.querySelector('[data-vm-buy-now]');

      function selectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-vm-option-index]').forEach(function (group) {
          var idx = group.getAttribute('data-vm-option-index');
          var active = group.querySelector('.is-selected');
          opts[idx] = active ? active.getAttribute('data-value') : null;
        });
        return opts;
      }

      function findVariant() {
        var opts = selectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === opts[i]; });
        });
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-vm-unavailable-label') || 'Unavailable'; }
          if (buyNowBtn) buyNowBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_formatted;
        if (compareEl) {
          if (variant.compare_at_price_formatted) {
            compareEl.textContent = variant.compare_at_price_formatted;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (saveBadge) {
          var comparePrice = parseFloat((variant.compare_at_price_formatted || '').replace(/[^0-9.]/g, ''));
          var nowPrice = parseFloat((variant.price_formatted || '').replace(/[^0-9.]/g, ''));
          if (variant.compare_at_price_formatted && comparePrice > nowPrice) {
            var pct = Math.round(((comparePrice - nowPrice) / comparePrice) * 100);
            saveBadge.textContent = 'Save ' + pct + '%';
            saveBadge.hidden = false;
          } else {
            saveBadge.hidden = true;
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (submitBtn.getAttribute('data-vm-default-label') || 'Add to Bag')
            : (submitBtn.getAttribute('data-vm-unavailable-label') || 'Sold Out');
        }
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;

        var quickAddBtn = root.parentElement ? root.parentElement.querySelector('[data-vm-quick-add]') : null;
        if (quickAddBtn) {
          quickAddBtn.setAttribute('data-vm-quick-add', variant.id);
          quickAddBtn.disabled = !variant.available;
          quickAddBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
        }
        var stickyBtn = document.querySelector('[data-vm-sticky-add]');
        var stickyPrice = document.querySelector('.vm-sticky-atc__price');
        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          stickyBtn.textContent = variant.available
            ? (submitBtn ? submitBtn.getAttribute('data-vm-default-label') || 'Add to Bag' : 'Add to Bag')
            : (submitBtn ? submitBtn.getAttribute('data-vm-unavailable-label') || 'Sold Out' : 'Sold Out');
        }
        if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
      }

      root.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-value]');
        if (!opt || !root.contains(opt)) return;
        var group = opt.closest('[data-vm-option-index]');
        if (!group) return;
        group.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var label = group.querySelector('[data-vm-option-current]');
        if (label) label.textContent = opt.getAttribute('data-value');
        var swatchImage = opt.getAttribute('data-vm-swatch-image');
        if (swatchImage) {
          var galleryEl = document.querySelector('[data-vm-gallery]');
          if (galleryEl && typeof galleryEl.vmScrollToImage === 'function') {
            galleryEl.vmScrollToImage(swatchImage);
          }
        }
        updateUI();
      });

      updateUI();
    });
  }

  function initVariantPicker() {
    initVariantPickerIn(document);
  }

  /* ---------- Recently viewed ---------- */
  var VM_RECENT_KEY = 'vm_recently_viewed';

  function vmTrackRecentlyViewed() {
    var el = document.querySelector('[data-vm-current-product]');
    if (!el) return;
    var current;
    try { current = JSON.parse(el.textContent); } catch (e) { return; }
    if (!current || !current.id) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(VM_RECENT_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (p) { return p.id !== current.id; });
    list.unshift(current);
    list = list.slice(0, 12);
    localStorage.setItem(VM_RECENT_KEY, JSON.stringify(list));
  }

  function vmRenderRecentlyViewed() {
    var mount = document.querySelector('[data-vm-recently-viewed]');
    if (!mount) return;
    var currentEl = document.querySelector('[data-vm-current-product]');
    var currentId = null;
    if (currentEl) {
      try { currentId = JSON.parse(currentEl.textContent).id; } catch (e) {}
    }
    var list;
    try { list = JSON.parse(localStorage.getItem(VM_RECENT_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (p) { return p.id !== currentId; }).slice(0, 4);
    var section = mount.closest('[data-vm-recently-viewed-section]');
    if (!list.length) {
      if (section) section.hidden = true;
      return;
    }
    if (section) section.hidden = false;
    mount.innerHTML = list.map(function (p) {
      return '' +
        '<div class="vm-card">' +
        '  <a href="' + p.url + '" class="vm-card__media-link"><span class="vm-img-wrap vm-card__media">' +
        (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="vm-card__placeholder"></span>') +
        '  </span></a>' +
        '  <div class="vm-card__info">' +
        '    <a href="' + p.url + '" class="vm-card__title">' + p.title + '</a>' +
        '    <div class="vm-card__price"><span class="vm-card__price-now">' + p.price + '</span></div>' +
        '  </div>' +
        '</div>';
    }).join('');
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    document.querySelectorAll('[data-vm-search-input]').forEach(function (input) {
      if (input.dataset.vmSearchBound) return;
      input.dataset.vmSearchBound = 'true';
      var scope = input.closest('[data-vm-search-scope]') || input.parentElement.parentElement || document;
      var results = scope.querySelector('[data-vm-search-results]');
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          if (results) results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (!results) return;
              var res = data.resources.results;
              var html = '';
              if (res.collections && res.collections.length) {
                html += '<div class="vm-search-group"><span class="vm-search-group__label">Categories</span>' +
                  res.collections.map(function (c) {
                    return '<a class="vm-search-collection" href="' + c.url + '">' + c.title + '</a>';
                  }).join('') + '</div>';
              }
              if (res.products && res.products.length) {
                html += '<div class="vm-search-group"><span class="vm-search-group__label">Products</span>' +
                  res.products.map(function (p) {
                    return '<a class="vm-search-product" href="' + p.url + '">' +
                      (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                      '<span><span class="vm-search-product__title">' + p.title + '</span>' +
                      '<span class="vm-search-product__price">' + p.price + '</span></span></a>';
                  }).join('') + '</div>';
              }
              if (res.queries && res.queries.length) {
                html += '<div class="vm-search-group"><span class="vm-search-group__label">Suggestions</span>' +
                  res.queries.map(function (q2) {
                    return '<a class="vm-search-suggestion" href="/search?q=' + encodeURIComponent(q2.text) + '">' + q2.text + '</a>';
                  }).join('') + '</div>';
              }
              results.innerHTML = html || '<p class="vm-search-empty">No results found.</p>';
            });
        }, 220);
      });
    });
  }

  /* ---------- Infinite scroll on collection pages ----------
     Replaces numbered pagination: fetches the next page's products via
     fetch() and appends them to the grid when the sentinel at the bottom
     scrolls into view. Re-attaches itself whenever facets.js swaps out
     #ProductGridContainer (sorting/filtering), since that wipes the old
     sentinel and observer along with everything else in the container. */
  function initInfiniteScroll() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var observer = null;

    function loadNext(sentinel) {
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl) {
        if (observer) observer.disconnect();
        return;
      }
      sentinel.setAttribute('data-loading', 'true');
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var currentGrid = document.getElementById('product-grid');
          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach(function (item) {
              currentGrid.appendChild(item);
            });
          }
          var newSentinel = doc.getElementById('vm-infinite-scroll-sentinel');
          if (newSentinel && newSentinel.getAttribute('data-next-url')) {
            sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          } else {
            sentinel.remove();
            if (observer) observer.disconnect();
          }
          sentinel.removeAttribute('data-loading');
        })
        .catch(function () {
          sentinel.removeAttribute('data-loading');
        });
    }

    function isNearViewport(sentinel) {
      var rect = sentinel.getBoundingClientRect();
      return rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 400;
    }

    function checkFallback() {
      var sentinel = document.getElementById('vm-infinite-scroll-sentinel');
      if (!sentinel) return;
      if (sentinel.getAttribute('data-loading') === 'true') return;
      if (isNearViewport(sentinel)) loadNext(sentinel);
    }

    function attach() {
      if (observer) observer.disconnect();
      var sentinel = document.getElementById('vm-infinite-scroll-sentinel');
      if (!sentinel) return;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && sentinel.getAttribute('data-loading') !== 'true') {
              loadNext(sentinel);
            }
          });
        }, { rootMargin: '400px 0px' });
        observer.observe(sentinel);
      }
      /* Belt-and-suspenders: also check on scroll/resize directly, in case
         IntersectionObserver never fires in some browser/embedded-webview
         context. Throttled with a plain setTimeout (not
         requestAnimationFrame) — some embedded webviews never run a paint
         loop while backgrounded/off-screen, which would silently starve an
         rAF-based throttle forever. */
      checkFallback();
    }

    var scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      setTimeout(function () {
        checkFallback();
        scrollTicking = false;
      }, 150);
    }, { passive: true });
    window.addEventListener('resize', checkFallback);

    attach();
    new MutationObserver(attach).observe(container, { childList: true });
  }

  function initVmFilterBar() {
    var bar = document.querySelector('[data-vm-filter-bar]');
    if (!bar) return;

    var grid = document.getElementById('product-grid');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('.grid__item[data-vm-colors], .grid__item[data-vm-sizes]')) : [];

    function closeAllPanels(except) {
      bar.querySelectorAll('[data-vm-filter-panel]').forEach(function (p) {
        if (p !== except) p.hidden = true;
      });
    }

    bar.querySelectorAll('[data-vm-filter-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var panel = trigger.parentElement.querySelector('[data-vm-filter-panel]');
        var willOpen = panel.hidden;
        closeAllPanels();
        panel.hidden = !willOpen;
      });
    });

    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) closeAllPanels();
    });

    function applyFilters() {
      var selectedColors = Array.prototype.slice.call(bar.querySelectorAll('[data-vm-filter-color]:checked')).map(function (i) { return i.value; });
      var selectedSizes = Array.prototype.slice.call(bar.querySelectorAll('[data-vm-filter-size]:checked')).map(function (i) { return i.value; });

      items.forEach(function (item) {
        var itemColors = (item.getAttribute('data-vm-colors') || '').split('|').filter(Boolean);
        var itemSizes = (item.getAttribute('data-vm-sizes') || '').split('|').filter(Boolean);
        var colorMatch = selectedColors.length === 0 || selectedColors.some(function (c) { return itemColors.indexOf(c) > -1; });
        var sizeMatch = selectedSizes.length === 0 || selectedSizes.some(function (s) { return itemSizes.indexOf(s) > -1; });
        item.hidden = !(colorMatch && sizeMatch);
      });
    }

    bar.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', applyFilters);
    });

    bar.querySelectorAll('[data-vm-grid-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-vm-grid-cols');
        bar.querySelectorAll('[data-vm-grid-cols]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (grid) {
          grid.classList.toggle('vm-grid-cols-3', cols === '3');
        }
      });
    });
  }

  /* ---------- Guarantee cart item rows render, independent of the CSS file ----------
     The cart item layout has intermittently painted blank on some mobile
     browsers right after renderContents() replaces the drawer markup. Rather
     than keep trusting external stylesheet timing/propagation, apply the
     required layout as inline styles directly on the elements the moment
     they exist — inline styles always win and don't depend on any
     stylesheet having loaded. */
  function vmForceCartItemLayout(root) {
    if (!root) return;
    var items = root.querySelectorAll('.cart-item');
    items.forEach(function (item) {
      item.style.setProperty('display', 'grid', 'important');
      item.style.setProperty('grid-template-columns', '70px 1fr auto', 'important');
      item.style.setProperty('grid-template-areas', '"media details details" "media quantity totals"', 'important');
      item.style.setProperty('column-gap', '14px', 'important');
      item.style.setProperty('row-gap', '10px', 'important');
      item.style.setProperty('align-items', 'start', 'important');
      item.style.setProperty('visibility', 'visible', 'important');
      item.style.setProperty('opacity', '1', 'important');
      var media = item.querySelector('.cart-item__media');
      var details = item.querySelector('.cart-item__details');
      var qty = item.querySelector('.cart-item__quantity');
      var totals = item.querySelector('.cart-item__totals');
      [media, details, qty, totals].forEach(function (cell) {
        if (cell) cell.style.setProperty('visibility', 'visible', 'important');
      });
      if (media) media.style.setProperty('grid-area', 'media', 'important');
      if (details) details.style.setProperty('grid-area', 'details', 'important');
      if (qty) qty.style.setProperty('grid-area', 'quantity', 'important');
      if (totals) {
        totals.style.setProperty('grid-area', 'totals', 'important');
        totals.style.setProperty('justify-self', 'end', 'important');
      }
      var img = item.querySelector('.cart-item__image');
      if (img) {
        img.style.setProperty('visibility', 'visible', 'important');
        img.style.setProperty('display', 'block', 'important');
        img.style.setProperty('width', '70px', 'important');
        img.style.setProperty('height', '70px', 'important');
        img.style.setProperty('object-fit', 'cover', 'important');
      }
    });
  }

  /* The root cause: <cart-drawer> gets an `is-empty` class from Liquid only
     at the initial page load, based on whether the cart was empty at that
     moment. Dawn's own renderContents() only ever clears `is-empty` off
     .drawer__inner (which never actually carries that class — looks like a
     stock Dawn bug), so on a first add-to-cart from an empty-cart page load,
     <cart-drawer> keeps `is-empty` forever. component-cart.css's generic
     `.is-empty .cart__contents { display: none }` rule (meant for the
     standalone /cart page) then matches inside the drawer too and hides the
     whole item form — explaining why this only ever broke on the very first
     add of a session. */
  function initCartDrawerReflowFix() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    /* Some mobile browsers (seen on Safari/iOS) resolve the cart-drawer-items
       update asynchronously, later than two animation frames after
       renderContents() returns — the row's box (borders/padding) shows up
       but its content (image, title, price, qty) never gets forced visible
       because our reflow calls already ran and finished by the time the
       real content lands. A MutationObserver re-applies the fix on every
       DOM change instead of guessing a fixed number of frames/timeouts. */
    var itemsWatcher = null;
    function watchCartItems() {
      var itemsEl = cartDrawer.querySelector('cart-drawer-items');
      if (!itemsEl) return;
      if (itemsWatcher) itemsWatcher.disconnect();
      itemsWatcher = new MutationObserver(function () {
        vmForceCartItemLayout(cartDrawer);
      });
      itemsWatcher.observe(itemsEl, { childList: true, subtree: true });
    }

    var original = cartDrawer.renderContents.bind(cartDrawer);
    cartDrawer.renderContents = function (parsedState) {
      original(parsedState);
      cartDrawer.classList.remove('is-empty');
      var itemsEl = cartDrawer.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');
      vmForceCartItemLayout(cartDrawer);
      watchCartItems();
      var inner = cartDrawer.querySelector('.drawer__inner');
      if (!inner) return;
      requestAnimationFrame(function () {
        vmForceCartItemLayout(cartDrawer);
        void inner.offsetHeight;
        requestAnimationFrame(function () {
          vmForceCartItemLayout(cartDrawer);
          void inner.offsetHeight;
        });
      });
      [100, 400, 900].forEach(function (delay) {
        setTimeout(function () { vmForceCartItemLayout(cartDrawer); }, delay);
      });
    };
    if (typeof cartDrawer.open === 'function') {
      var originalOpen = cartDrawer.open.bind(cartDrawer);
      cartDrawer.open = function (triggeredBy) {
        originalOpen(triggeredBy);
        vmForceCartItemLayout(cartDrawer);
        watchCartItems();
        requestAnimationFrame(function () { vmForceCartItemLayout(cartDrawer); });
        [100, 400, 900].forEach(function (delay) {
          setTimeout(function () { vmForceCartItemLayout(cartDrawer); }, delay);
        });
      };
    }
    watchCartItems();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartDrawerReflowFix();
    initInfiniteScroll();
    initVmFilterBar();
    initReveal();
    initTransparentHeader();
    initWishlistButtons();
    initDrawerTriggers();
    initMenuDrawerAutoScroll();
    initCardHoverImages();
    initQuickView();
    initShareButton();
    initCarousels();
    initZoom();
    initAccordions();
    initSwatchPreview();
    initQuickAdd();
    initGallery();
    initVariantPicker();
    initProductForm();
    initStickyAtc();
    initCartCrossSell();
    initFrequentlyBoughtTogether();
    initPredictiveSearch();
    vmTrackRecentlyViewed();
    vmRenderRecentlyViewed();
  });
})();

function initGtranslateFlagFix() {
  // GTranslate's own show/hide logic for the other language flags is
  // unreliable (they stay display:none on click/hover in practice), so
  // drive the open/closed state ourselves instead of depending on it.
  var isOpen = false;

  // The app injects its own inline-!important-strength positioning via a
  // per-load ID selector (#gt-wrapper-XXXX .gsatelites), which beats any
  // class-based CSS override regardless of specificity tricks. Setting the
  // properties directly via JS creates a true inline style, which is the
  // only thing that reliably outranks it.
  function fixWrapper(el) {
    el.style.setProperty('right', '12px', 'important');
    el.style.setProperty('left', 'auto', 'important');
  }
  function fixContainer(el) {
    el.style.setProperty('right', '0', 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', '320px', 'important');
    el.style.setProperty('overflow-y', 'auto', 'important');
    // The pill itself (the .gsatelites background) stays rendered even
    // with all its flags display:none, showing an empty white bar over
    // page content — hide it outright until the user opens the widget.
    if (!isOpen) el.style.setProperty('display', 'none', 'important');
  }
  function fixAll(root) {
    root.querySelectorAll('.gt_switcher_wrapper').forEach(fixWrapper);
    root.querySelectorAll('.gsatelites').forEach(fixContainer);
  }
  fixAll(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('gt_switcher_wrapper')) fixWrapper(node);
        if (node.classList && node.classList.contains('gsatelites')) fixContainer(node);
        fixAll(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function setOpen(state) {
    isOpen = state;
    document.querySelectorAll('.gsatelites').forEach(function (c) {
      c.style.setProperty('display', state ? 'flex' : 'none', 'important');
    });
    document.querySelectorAll('.gsatelite:not(.gt-current-lang)').forEach(function (a) {
      a.style.setProperty('display', state ? 'inline-block' : 'none', 'important');
      // Without this they stay position:absolute at a stale, un-computed
      // spot (GTranslate's own fan-out animation never ran) and stack on
      // top of each other instead of flowing in the flex row.
      a.style.setProperty('position', 'static', 'important');
      a.style.setProperty('margin', '2px', 'important');
      // GTranslate lazy-loads flag icons via a custom data attribute that
      // only its own (bypassed) open handler swaps to a real src.
      var img = a.querySelector('img[data-gt-lazy-src]');
      if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-gt-lazy-src'));
    });
  }
  // Capture phase: GTranslate's own click handler on the icon likely
  // calls stopPropagation(), which would stop a normal bubble-phase
  // listener on document from ever seeing a real user click. Capture
  // runs top-down before that, so it can't be blocked that way.
  document.addEventListener('click', function (e) {
    var wrapper = e.target.closest && e.target.closest('.gt_switcher_wrapper');
    if (wrapper) {
      setOpen(!isOpen);
    } else if (isOpen) {
      setOpen(false);
    }
  }, true);
}
document.addEventListener('DOMContentLoaded', initGtranslateFlagFix);
if (document.readyState !== 'loading') initGtranslateFlagFix();
